import { User, UserFull } from '@wellesley/openapi'

const isBotProfile = (user: User | UserFull) => {
  return user.actorType === 'Service'
}

export default isBotProfile
